module.exports = __webpack_public_path__ + "static/preview-5-abd64d3ac07054effbd28913ff944d2d.png";